import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Favorito`

export function buscarTodos(idUsuario) {
  return http.get(`${API_ENDPOINT}/BuscarTodos/${idUsuario}`)
}

export function buscarPorId(idPublicacion) {
  return http.get(`${API_ENDPOINT}/BuscarPorId/${idPublicacion}`)
}

export function buscarPorUsuario(idUsuario) {
  return http.get(`${API_ENDPOINT}/BuscarPorUsuario/${idUsuario}`)
}

export function insertar(idPublicacion) {
  return http.post(API_ENDPOINT, idPublicacion)
}

export function eliminar(idPublicacion) {
  return http.delete(API_ENDPOINT, idPublicacion)
}
